import { baseApi } from "@/shared/api/baseApi";

import {
  AtualizarConfiguracoesSessaoPayload,
  ConfiguracoesSessao,
} from "../types";

export const configuracaoSessaoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /** Lookup — sem RequirePermission. Usado pelo AppLayout (polling de timeout). */
    buscarConfiguracaoSessao: builder.query<ConfiguracoesSessao, void>({
      query: () => "/api/configuracao-sessao/lookup",
    }),
    /** Obter — com RequirePermission. Usado pela tela de edição (admin). */
    obterConfiguracaoSessao: builder.query<ConfiguracoesSessao, void>({
      query: () => "/api/configuracao-sessao",
    }),
    atualizarConfiguracaoSessao: builder.mutation<
      void,
      AtualizarConfiguracoesSessaoPayload
    >({
      query: (body) => ({
        url: "/api/configuracao-sessao",
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useBuscarConfiguracaoSessaoQuery,
  useObterConfiguracaoSessaoQuery,
  useAtualizarConfiguracaoSessaoMutation,
} = configuracaoSessaoApi;
